<div class="image_upload_container">

    <div class="modal-header">

        <h4>File View (Using ng2-pdfjs-viewer)</h4>

    </div>

    <div class="modal-body">

        <ng-container *ngIf="fileType === constants.FILE_TYPE_PDF; else imageViewer">
            <!-- <ng2-pdfjs-viewer [pdfSrc]="pdfBlobUrl" [viewerId]="'pdfjs-viewer'"
                style="width: 100%; height: 500px; display: block;"></ng2-pdfjs-viewer> -->
        </ng-container>
        <ng-template #imageViewer>
            <img [src]="utils.isEmpty(fileBase64Data) === true ? 'assets/images/defaultImage.png' : fileBase64Data">
        </ng-template>

    </div>

    <div class="modal-footer">

        <button type="button" class="btn" (click)="closeModal()">OK</button>

    </div>

</div>